import React, { Fragment, useState } from "react";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
    Checkbox,
    FormControlLabel,
    TableCell,
    TableRow,
    Tooltip,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ConfirmationModal } from "components/organisms/ConfirmationModal";

import { deleteDestination } from "helpers/destinations/deleteDestination";
import getDestinationIcon from "helpers/destinations/getDestinationIcon";
import isDestinationDeletable from "helpers/source/isDestinationDeletable";

import { getDestinationForAddingTrackers } from "../redux/slices/destinations/destinations.asyncActions";
import SwalAlertComp from "./SwalAlert";

/**
 * @description TODO: It should be centralised with other modals under modals folder
 */
const DestinationTableContainerOld = ({
    existDestinations,
    selectedDestination,
    selectedItems,
    setSelectedItems,
    CheckHandlerDestination,
    availableDestinations = [],
}) => {
    const dispatch = useDispatch();
    const params = useParams();

    const language = useSelector((state) => state.languagesState.languages);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [pendingId, setPendingId] = useState(null);

    const getAllDestionations = async () => {
        await dispatch(getDestinationForAddingTrackers(params.id && params.id));
    };

    const deleteDestinationHandler = async (id) => {
        let response = await deleteDestination(id);
        if (response.status) {
            SwalAlertComp({
                title: language?.delete_swal_modal?.success ?? "Success",
                message: response.message,
                icon: "success",
                timer: 3000,
            });
            getAllDestionations();
            const copySelectedItems = { ...selectedItems };
            delete copySelectedItems[id];
            setSelectedItems(copySelectedItems);
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response.message,
                icon: "error",
            });
        }
    };
    const getDestinationIconHandler = (arr, id) => {
        if (arr) {
            let _newDestination = [...arr];
            if (
                _newDestination.find((x) => x.destination_type_id === id) !==
                undefined
            ) {
                let code = _newDestination.find(
                    (x) => x.destination_type_id === id,
                ).destination_type.code;
                return getDestinationIcon(code);
            }
        }
    };
    return (
        <Fragment>
            <ConfirmationModal
                open={confirmOpen}
                onClose={() => { setConfirmOpen(false); setPendingId(null); }}
                onConfirm={() => { deleteDestinationHandler(pendingId); setConfirmOpen(false); setPendingId(null); }}
                title={language?.delete_swal_modal?.are_you_sure ?? "Are you sure?"}
                message="This action cannot be undone."
                confirmColor="error"
            />
            {existDestinations &&
                existDestinations.length > 0 &&
                existDestinations.map((item) => {
                    const isDeletable = isDestinationDeletable(item);
                    const isAvailable = availableDestinations.includes(
                        item?.destination_type?.code,
                    );

                    return (
                        <TableRow
                            key={item.id}
                            sx={{ opacity: isAvailable ? 1 : 0.6 }}
                        >
                            <TableCell className="table-name-cell">
                                {isAvailable ? (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={
                                                    selectedDestination[
                                                        item?.id
                                                    ]
                                                }
                                                onChange={(e) => {
                                                    CheckHandlerDestination(
                                                        e,
                                                        item,
                                                    );
                                                }}
                                            />
                                        }
                                        label={item.name}
                                    />
                                ) : (
                                    <Tooltip
                                        title="Pixel destinations only accept Website JS-based web events. CRM, offline, or messaging events cannot be sent to these destinations."
                                        placement="right"
                                        arrow
                                        enterDelay={300}
                                        leaveDelay={200}
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    bgcolor:
                                                        "rgba(0, 0, 0, 0.9)",
                                                    maxWidth: 250,
                                                    fontSize: "0.875rem",
                                                    "& .MuiTooltip-arrow": {
                                                        color: "rgba(0, 0, 0, 0.9)",
                                                    },
                                                },
                                            },
                                        }}
                                    >
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    disabled
                                                    checked={false}
                                                    sx={{
                                                        "&.Mui-disabled": {
                                                            color: "rgba(0, 0, 0, 0.26)",
                                                        },
                                                    }}
                                                />
                                            }
                                            label={
                                                <span
                                                    style={{
                                                        textDecoration:
                                                            "line-through",
                                                        color: "rgba(0, 0, 0, 0.6)",
                                                    }}
                                                >
                                                    {item.name}
                                                </span>
                                            }
                                        />
                                    </Tooltip>
                                )}
                            </TableCell>
                            <TableCell>
                                <div className="wizard-step-title">
                                    <img
                                        alt="icon"
                                        className="source-icon"
                                        src={getDestinationIconHandler(
                                            existDestinations,
                                            item?.destination_type?.id,
                                        )}
                                    />
                                    {item?.destination_type?.name ?? ""}
                                </div>
                            </TableCell>
                            <TableCell className="text-right">
                                <Tooltip
                                    title={
                                        !isDeletable &&
                                        "Source is already in use !"
                                    }
                                >
                                    <div
                                        className={`icon-area-old ${isDeletable ? "" : "disabled"}`}
                                    >
                                        <a
                                            href="javascript:;"
                                            className={`delete-icon ${isDeletable ? "" : "disabled"}`}
                                            onClick={() => {
                                                if (isDeletable) {
                                                    setPendingId(item?.id);
                                                    setConfirmOpen(true);
                                                }
                                            }}
                                        >
                                            <DeleteOutlineIcon></DeleteOutlineIcon>
                                        </a>
                                    </div>
                                </Tooltip>
                            </TableCell>
                        </TableRow>
                    );
                })}
        </Fragment>
    );
};

export default DestinationTableContainerOld;
